import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function TourGuide() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 bg-background-100/50">
      <div className="max-w-[800px] mx-auto px-8">
        <div className="text-center mb-10">
          {String(t('facilities.tour.label')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">{__s}</p>))}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('facilities.tour.title')}
          </h2>
          {String(t('facilities.tour.titleEn')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="section-title-en text-accent-500 text-[15px] tracking-[0.12em] mb-4">{__s}</p>))}
          <div className="gold-line mx-auto"></div>
          {String(t('facilities.tour.lead')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[15px] text-foreground-500 tracking-[0.04em] leading-relaxed max-w-[600px] mx-auto mt-5">{__s}</p>))}
        </div>

        <div className="border border-background-200/60 bg-background-50 p-8">
          <div className="space-y-5">
            <div className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-6">
              <div className="flex items-center gap-3 flex-shrink-0 min-w-[140px]">
                <div className="w-8 h-8 flex items-center justify-center bg-accent-500/10 rounded-full flex-shrink-0">
                  <i className="ri-calendar-check-line text-accent-600 text-sm"></i>
                </div>
                <span className="text-[15px] text-foreground-800 tracking-[0.05em] font-medium whitespace-nowrap">
                  {t('facilities.tour.booking.label')}
                </span>
              </div>
              {String(t('facilities.tour.booking.text')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[14px] text-foreground-500 tracking-[0.04em] leading-relaxed">{__s}</p>))}
            </div>

            <div className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-6">
              <div className="flex items-center gap-3 flex-shrink-0 min-w-[140px]">
                <div className="w-8 h-8 flex items-center justify-center bg-accent-500/10 rounded-full flex-shrink-0">
                  <i className="ri-time-line text-accent-600 text-sm"></i>
                </div>
                <span className="text-[15px] text-foreground-800 tracking-[0.05em] font-medium whitespace-nowrap">
                  {t('facilities.tour.duration.label')}
                </span>
              </div>
              {String(t('facilities.tour.duration.text')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[14px] text-foreground-500 tracking-[0.04em] leading-relaxed">{__s}</p>))}
            </div>

            <div className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-6">
              <div className="flex items-center gap-3 flex-shrink-0 min-w-[140px]">
                <div className="w-8 h-8 flex items-center justify-center bg-accent-500/10 rounded-full flex-shrink-0">
                  <i className="ri-phone-line text-accent-600 text-sm"></i>
                </div>
                <span className="text-[15px] text-foreground-800 tracking-[0.05em] font-medium whitespace-nowrap">
                  {t('facilities.tour.how.label')}
                </span>
              </div>
              {String(t('facilities.tour.how.text')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[14px] text-foreground-500 tracking-[0.04em] leading-relaxed">{__s}</p>))}
            </div>

            <div className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-6">
              <div className="flex items-center gap-3 flex-shrink-0 min-w-[140px]">
                <div className="w-8 h-8 flex items-center justify-center bg-accent-500/10 rounded-full flex-shrink-0">
                  <i className="ri-information-line text-accent-600 text-sm"></i>
                </div>
                <span className="text-[15px] text-foreground-800 tracking-[0.05em] font-medium whitespace-nowrap">
                  {t('facilities.tour.note.label')}
                </span>
              </div>
              {String(t('facilities.tour.note.text')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[14px] text-foreground-500 tracking-[0.04em] leading-relaxed">{__s}</p>))}
            </div>
          </div>

          <div className="mt-8 pt-6 border-t border-background-200/60">
            <Link
              to="/access"
              className="text-[15px] text-accent-600 hover:text-accent-500 tracking-[0.05em] transition-colors inline-flex items-center gap-2"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-map-pin-line text-xs"></i>
              </div>
              {t('facilities.tour.accessLink')}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
